import { render, staticRenderFns } from "./getESG.vue?vue&type=template&id=4d899770&"
import script from "./getESG.vue?vue&type=script&lang=js&"
export * from "./getESG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports